export default {
  bind(el, binding, vnode) {
    const styleType = binding.arg
    const dragEl = el.querySelector('.drap-handle')
    if (styleType == 'width') {
      dragEl.style.cssText += ';cursor:col-resize;';
    } else {
      dragEl.style.cssText += ';cursor:row-resize;';
    }


    dragEl.onmousedown = (e) => {
      const startX = e.clientX,
        startY = e.clientY,
        elwidth = el.clientWidth,
        elheight = el.clientHeight
      document.onmousemove = function (e) {
        var endX = e.clientX,
          endY = e.clientY;
        var finalPoint = styleType == 'width' ? (endX - startX + elwidth) : (startY - endY + elheight)
        if(finalPoint < 0){
          finalPoint = 0
        }

        if (styleType == 'height' && finalPoint <= 45) {
          finalPoint = 45
        }
        if (styleType == 'height' && finalPoint >= 450) {
          finalPoint = 450
        }

        el.style[styleType] = `${finalPoint}px`
        if (styleType == 'width' && finalPoint >= 300) {
          let searchLeft = el.parentNode.getElementsByClassName('monitor-wrapper--search')[0]
          searchLeft.style.left = `${finalPoint + 20}px`
        }
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
